import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";

export default class ClientLineItem {
    constructor(item) {
        this.initialize(item);
        this.Selected = false;
    }

    async initialize(item) {
        this.ClId = item.clId;
        this.ClCircycode = item.clCircycode;
        this.ClCiid = item.clCiid;
        this.ClCircycode = item.clCircycode;
        this.ClTotal = item.clTotal;
        this.ClLliname = item.clLliname;
        this.ClCfDisplayName = item.clCfDisplayName === null ? " " : item.clCfDisplayName;
        this.ClDesc = item.clDesc;
        this.ClInitialDue = item.clInitialDue;
        this.ClCredit = item.clCredit;
        this.ClTax = item.clTax;
        this.ClPaid = item.clPaid;
        this.ClCurrent = item.clCurrent;
        this.ClApplyVat = item.clApplyVat;
        this.ClCfid = item.clCfid;
        this.CiCcid = item.ciCcid;
    }

    static NameOfTheIdField() { return "ClId"; }
    static nameOfTheItemDetailList() { return "Client Line"; }
    static MoneyFields = [
        "ClTotal",
        "ClInitialDue",
        "ClCredit",
        "ClTax",
        "ClPaid",
        "ClCurrent"
    ];
    static Currency() { return "ClCircycode" };
    static MoneyFieldsSecondary = [];
    static CurrencySecondary() { return "" };
    static DateFields = [];
    static BoolFields = ["ClApplyVat"];

    static FieldsToShowInListTable = [
        {
            tabName: "General",
            tabLabel: "General",
            icon: "fa-solid fa-users",
            data: [
                { name: "ClCiid", label: "Bare Invoice #", className: "text-left" },
                { name: "ClCircycode", label: "Currency", className: "text-left" },
                { name: "ClTotal", label: "Client Fee", className: "text-left" },
                { name: "ClLliname", label: "Type", className: "text-left" },
                { name: "ClCfDisplayName", label: "Project", className: "text-left" },
                { name: "ClDesc", label: "Description", className: "text-left", width: TabListTableCellWidthEnum.TwoLines },
                { name: "ClInitialDue", label: "Initial Total", className: "text-left" },
                { name: "", label: "" },
                { name: "", label: "" },
                { name: "ClCredit", label: "Credit", className: "text-left" },
                { name: "", label: "" },
                { name: "", label: "" },
                { name: "ClTax", label: "Tax", className: "text-left" },
                { name: "", label: "" },
                { name: "", label: "" },
                { name: "ClPaid", label: "Paid", className: "text-left" },
                { name: "", label: "" },
                { name: "", label: "" },
                { name: "ClCurrent", label: "Current Due", className: "text-left" },
                { name: "-", label: "Legacy Tax Details" },
                { name: "ClApplyVat", label: "Apply Tax", className: "text-left" },
            ]
        },
    ];

    static FieldsToShowInDataTable() {
        return [
            {},
        ];
    }

}